// extracted by mini-css-extract-plugin
module.exports = {"container":"Soon_container__3VqEK","container_div":"Soon_container_div__1G5zG","text":"Soon_text__3JL4z"};